var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{attrs:{"lg":"6","md":"6","sm":"10","cols":"12"}},[_c('NewPasswordForm',{attrs:{"confirmLastPassword":false},on:{"password":_vm.changePassword}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }